import { fetchUser } from "actions/user";
import RequireData from "hooks/RequireData";
import SageErrorAlert from "kit/SageErrorAlert";
import React from "react";
import { ListGroup, ListGroupItem, Badge } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import memberTeamsSelector from "selectors/memberTeams";
import memberTeamsStatusSelector from "selectors/memberTeamsStatus";
import userSelector from "selectors/user";
import styles from "./TeamsMember.module.scss";

const TeamsMember: React.FC = () => {
    const history = useHistory();
    const [user] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );
    const [teams, status] = RequireData(
        memberTeamsSelector,
        memberTeamsStatusSelector,
        {
            type: "com.sage.actions.team.IFetchMemberTeams",
        } as sage.actions.team.IFetchMemberTeams
    );
    const listItemAction = React.useCallback(
        (teamId: string) => () => {
            history.push(`/home/teams/team/${teamId}`);
        },
        [history]
    );

    return (
        <div>
            <h4 className={styles.header}>Teams Your Apart Of</h4>
            {status === "loading" && <p>Loading...</p>}
            {status === "error" && <SageErrorAlert />}
            {status === "none" && teams && (
                <ListGroup>
                    {teams.map((t) => (
                        <ListGroupItem
                            action={true}
                            onClick={listItemAction(t.id)}
                            key={t.id}
                        >
                            {t.name}{" "}
                            {user && user?.id === t.owner_id && (
                                <Badge variant="primary">Owner</Badge>
                            )}
                        </ListGroupItem>
                    ))}
                </ListGroup>
            )}
            {status === "none" && teams && teams.length === 0 && (
                <p>You are not apart of any teams.</p>
            )}
        </div>
    );
};

export default TeamsMember;
